import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroCultureIndexLocationGroupId,
  setGroupId,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { useCallback } from 'react';
import { store } from 'redux/store';
import useLocationGroups from '../../useLocationGroups';

export default function useGroupOptions() {
  const { groups } = useLocationGroups();
  const selectedGroupId = useSelector(selectMeteorologyAgroCultureIndexLocationGroupId);
  const setGroup = useCallback((id: number) => {
    store.dispatch(setGroupId(id));
  }, []);

  return {
    availableGroups: groups || [],
    selectedGroupId,
    setGroup,
  };
}
